import dashboardBannerApi from "@/api/dashboardBanner.api"

export const fetchPortalBanners = async ({ commit }) => {
  commit("setBanners", await dashboardBannerApi.getAll())
}

export const savePortalBanner = async (vuex, { banner, file }) => {
  await dashboardBannerApi.update(banner, file)
}

export const removePortalBanner = async (vuex, planType) => {
  await dashboardBannerApi.remove(planType)
}
